import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm: any;
  response: any;
  loginResponse: any;
  isLoading = false;

  constructor(
    private _authService: AuthService,
    private _router: Router,
    private _fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    localStorage.clear();
    this._authService.isLoggedIn.subscribe((_isLoggedIn: boolean) => {
      if (_isLoggedIn) {
        this._router.navigate(['/change-viewer']);
      }
    });
    this.createForm();
  }

  createForm() {
    this.loginForm = this._fb.group({
      'EmailId': [null, Validators.compose([
        Validators.required,
        Validators.email
      ])],
      'Password': [null, Validators.required]
    });
  }
}
